import { render, staticRenderFns } from "./reviewWorks.vue?vue&type=template&id=14485668&scoped=true&"
import script from "./reviewWorks.vue?vue&type=script&lang=js&"
export * from "./reviewWorks.vue?vue&type=script&lang=js&"
import style0 from "./reviewWorks.vue?vue&type=style&index=0&id=14485668&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14485668",
  null
  
)

export default component.exports